export default "__VITE_ASSET__DNp_ow$V__"